import React, { PureComponent, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { HOMESTAY, PATHS } from '../../../../../constants/Define';
import i18n from '../../../../../constants/initLng';
import { ListComponent, StatusComponent } from "../../../common/component/Index";
import { withTranslation } from "react-i18next";
import { Icon, message, Popconfirm, Tooltip } from 'antd';
import { DragSource, DropTarget } from 'react-dnd';
import Ripple from '../../../common/component/Ripple';
import HomestayRate from '../../../../../models/HomestayRate';
import { FlagIcons, FlagIconsRatePlan } from '../../../common/component/TranslateButton';
import _, { isEqual } from 'lodash';
import './style.less'
import EllipsisText from '../../../common/component/EllipsisText';
import { dataCustomerAction } from '../../../../../actions/customerAction';
import CONFIG from '../../../../../constants/Config';
import { RATE_SYNC_RATES_ACTION } from '../../../../../constants/Types';
import * as HMS from "../../../common/component/Index";
import * as ANT from 'antd';
import { faRecordVinyl } from '@fortawesome/free-solid-svg-icons';
import AutoTranslateModal from './Components/AutoTranslateModal';
import Modal from '../../../common/component/Modal';

const ListCols = ['id', 'typeHomestayRate', 'dc', 'code', 'name', 'description', 'promotions', 'shortDescription', 'isIndependent',"refStatus", 'isActive', 'order', 'translations'];
const ModelFields = Object.getOwnPropertyNames(new HomestayRate());

let dragingIndex = -1;

class BodyRow extends React.Component {
  render() {
    const { isOver, connectDragSource, connectDropTarget, moveRow, getListHomestayRates, ...restProps } = this.props;
    const style = { ...restProps.style, cursor: 'move' };
    let { className } = restProps;
    if (isOver) {
      if (restProps.index > dragingIndex) {
        className += ' drop-over-downward';
      }
      if (restProps.index < dragingIndex) {
        className += ' drop-over-upward';
      }
    }

    return connectDragSource(
      connectDropTarget(<tr {...restProps} className={className} style={style} />),
    );
  }
}

class HomestayRateList extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      itemRow: {},
      titleItemTable: Func.getTitleTable(ListCols, ['action'], ['id', 'shortDescription', 'dc']),
      modelItem: ModelFields,
      componentTable: {
        typeHomestayRate: {
          key: 'DC',
          align: 'center',
          // filters: [
          //   { value: Object.entries(HOMESTAY.TYPE_RATE[CONFIG.ENV])[0][0], text: this.props.t(`item.homestayRate.filters.homestay`) },
          //   { value: Object.entries(HOMESTAY.TYPE_RATE[CONFIG.ENV])[1][0], text: this.props.t(`item.homestayRate.filters.bundle`) },
          // ],
          // render: (text, record) => record?.dc.map(typeId => <StatusComponent color={HOMESTAY.TYPE_RATE[CONFIG.ENV][typeId] === 'Bundle' ? 'geekblue' : 'red'}
          //   label={HOMESTAY.TYPE_RATE[CONFIG.ENV][typeId]} />)
          render: (text, record) => <StatusComponent color={'red'} label={'Hotel'} />
        },
        name: {
          key: 'name',
          width: 150,
          filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <HMS.FilterDropdown
              setSelectedKeys={setSelectedKeys}
              selectedKeys={selectedKeys}
              confirm={confirm}
              clearFilters={clearFilters}
            >
            </HMS.FilterDropdown>
          ),
          filterIcon: filtered => (
            <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
          ),
          render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={150}
            overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
        },
        code: {
          key: 'code',
          align: 'center',
          filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <HMS.FilterDropdown
              setSelectedKeys={setSelectedKeys}
              selectedKeys={selectedKeys}
              confirm={confirm}
              clearFilters={clearFilters}
            >
            </HMS.FilterDropdown>
          ),
          filterIcon: filtered => (
            <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
          ),
        },
        description: {
          key: 'description',
          width: 150,
          // filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          //   <HMS.FilterDropdown
          //     setSelectedKeys={setSelectedKeys}
          //     selectedKeys={selectedKeys}
          //     confirm={confirm}
          //     clearFilters={clearFilters}
          //   >
          //   </HMS.FilterDropdown>
          // ),
          // filterIcon: filtered => (
          //   <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
          // ),
          render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={150}
            overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
        },
        promotions: {
          key: 'promotions',
          width: 150,
          render: (promotions, record) => {
            let text = '';
            if (promotions) {
              text = promotions.join(', ')
            }
            return <EllipsisText title={text} content={text} contentMaxWidth={150} overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
          }
        },
        isIndependent: {
          key: 'isIndependent',
          width: 120,
          render: (isExtend, record) =>
            <FlagIconsRatePlan
              languages={record.translations.filter(translate => !!translate.isIndependent)} />
        },
        refStatus: {
          key: 'refStatus',
          filters: [
            { value: true, text: this.props.t(`item.homestayRate.filters.active`) },
            { value: false, text: this.props.t(`item.homestayRate.filters.deActive`) },
          ],
          render: (refStatus, record) =>
            <StatusComponent color={refStatus ? 'green' : 'red'}
              label={refStatus ? this.props.t('item.homestayRate.active') : this.props.t('item.homestayRate.deactive')} />
        },
        isActive: {
          width: 120,
          key: 'isActive',
          filteredValue: null,
          filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <HMS.FilterRadioDropdown
              selectedKeys={selectedKeys}
              setSelectedKeys={setSelectedKeys}
              confirm={confirm}
              dataFilters={[
                { value: '__all__', text: 'All status' },
                { value: 'true', text: this.props.t(`item.homestayRate.filters.active`) },
                { value: 'false', text: this.props.t(`item.homestayRate.filters.deActive`) },
              ]}
              handleReset={() => {
                clearFilters();
                confirm();
              }}
              defaultValue="__all__"
            />
          ),
          filterIcon: filtered => (
            <ANT.Icon type="filter" style={{ color: filtered ? '#1890ff' : undefined }} />
          ),
          render: (isActive, record) => {
            return (
              <ANT.Switch
                checkedChildren={this.props.t('item.homestayRate.filters.active')}
                unCheckedChildren={this.props.t('item.homestayRate.filters.deActiveShort')}
                checked={isActive}
                style={{ width: '100%' }}
                loading={this.props.loadingStatus}
                onChange={value => this.onUpdateActive(value, record)}
              />
            )
          }
          // (
          //     <StatusComponent color={isActive ? 'green' : 'red'}
          //         label={isActive ? this.props.t('item.homestayRate.active') : this.props.t('item.homestayRate.deactive')} />
          // )
        },
        // isExtend: {
        //   key: 'isExtend',
        //   width: 120,
        //   render: (isExtend, record) => {
        //     return (
        //       <ANT.Switch
        //         checkedChildren={this.props.t('item.homestayRate.onIsExtend')}
        //         unCheckedChildren={this.props.t('item.homestayRate.offIsExtend')}
        //         checked={isExtend}
        //         style={{ width: '100%' }}
        //         loading={this.props.loadingExtendHomestayRate}
        //         onChange={value => this.onUpdateExtend(value, record)}
        //       />
        //     )
        //   }
        // },
        translations: {
          key: 'translations',
          width: 150,
          render: (text, record) => <FlagIconsRatePlan
            languages={record.translations} />,
        },
        action: {
          width: 100,
          align: 'center',
          key: 'action',
          fixed: 'right',
          render: (text, record) => this.renderEditComponent(record),
        }
      },
      filters: {},
      dataListHomestayRate: [],
      selectedFields: [],
      headSelectedIndex: 0,
      firstSelectedIndex: 0
    };
  }

  clearItemSelection() {
    this.setState({ selectedFields: [], headSelectedIndex: 0, firstSelectedIndex: 0 });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dataList && !isEqual(nextProps.dataList, this.props.dataList)) {
      this.setState({ dataListHomestayRate: nextProps.dataList });
      this.clearItemSelection();
    }
    if (!nextProps.isSort || !isEqual(nextProps.isSort, this.props.isSort)) {
      this.clearItemSelection();
    }
  }

  componentDidMount() {
  }

  rowSource = {
    beginDrag(props) {
      let dragFields;
      let headSelect;
      if (props.selectedFields.find(field => field.id === props.record.id)) {
        dragFields = props.selectedFields;
        headSelect = props.headSelectedIndex;
      } else {
        dragFields = [props.record];
        headSelect = props.index;
      }
      return {
        index: props.index,
        dragFields: dragFields,
        headSelectedIndex: headSelect
      };
    },
  };

  rowTarget = {
    drop(props, monitor) {
      const dragIndex = monitor.getItem().index;
      const dragFields = monitor.getItem().dragFields;
      const headSelect = monitor.getItem().headSelectedIndex;
      const hoverIndex = props.index;
      if (dragIndex === hoverIndex) {
        return;
      }
      props.moveRow(hoverIndex, dragFields, headSelect);
      monitor.getItem().index = hoverIndex;
    },
  };

  DragableBodyRow = DropTarget('row', this.rowTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
  }))(
    DragSource('row', this.rowSource, connect => ({
      connectDragSource: connect.dragSource(),
    }))(BodyRow),
  );

  components = {
    body: {
      row: this.DragableBodyRow,
    },
  };

  async handleRowSelection(shiftKey, index) {
    // if(index < this.state.firstSelectedIndex || !this.state.firstSelectedIndex){
    //   if(shiftKey && !this.state.firstSelectedIndex){
    //     await this.setState({firstSelectedIndex: 0});
    //   }else{
    //     await this.setState({firstSelectedIndex: index});
    //   }
    // }
    this.handleItemSelection(index, shiftKey)
  }

  handleItemSelection(index, shiftKey) {
    let { firstSelectedIndex } = this.state;
    let selectedFields;
    const fields = this.state.dataListHomestayRate;
    const field = index < 0 ? '' : fields[index];
    const lastSelectedIndex = index;
    if (!shiftKey) {
      this.setState({ firstSelectedIndex: index, headSelectedIndex: index });
      selectedFields = [field];
    } else if (shiftKey) {
      if (index > firstSelectedIndex) {
        selectedFields = [].concat(fields.slice(this.state.firstSelectedIndex, index + 1));
        this.setState({ headSelectedIndex: firstSelectedIndex });
      } else {
        selectedFields = [].concat(fields.slice(index, this.state.firstSelectedIndex + 1));
        this.setState({ headSelectedIndex: index });
      }
    }
    const finalList = fields ? fields
      .filter(f => selectedFields.find(a => a === f)) : [];
    this.setState({ selectedFields: finalList });
  }

  onUpdateActive = (value, data) => {
    this.props.onUpdateHomestayRateActive({
      res: {
        id: data.id,
        data: { isActive: value }
      },
      name: data.name
    });
  }

  onUpdateExtend = (value, data) => {
    this.props.onUpdateHomestayRateExtend({
      res: {
        id: data.id,
        data: { isExtend: value }
      },
      name: data.name
    })
  }

  onUpdateIndependent = (value, data) => {
    this.props.onUpdateHomestayRateExtend({
      res: {
        id: data.id,
        data: { isIndependent: value }
      },
      name: data.name
    })
  }

  render() {
    const { loading, isSort, moveRow, pagination } = this.props;
    const { titleItemTable, modelItem, componentTable, dataListHomestayRate, selectedFields, headSelectedIndex } = this.state;
    const activeFilteredValue = this.props.filters?.isActive !== undefined
      ? [(Array.isArray(this.props.filters.isActive) ? this.props.filters.isActive[0] : this.props.filters.isActive).toString()]
      : null;
    const normalizedComponentTable = {
      ...componentTable,
      isActive: {
        ...componentTable.isActive,
        filteredValue: activeFilteredValue
      }
    };
    return (
      <ListComponent
        tableKey="room-type-list"
        scroll={{ x: 1500 }}
        rowClassName={(record, index) => selectedFields.findIndex(item => item.id === record.id) > -1 && 'table-row-light'}
        classChildren="p-0" classParent="m-0"
        rowKey={(record, k) => record.id ? record.id : k}
        loading={{ spinning: loading, size: 'large' }}
        dataSource={Func.getDataSource(dataListHomestayRate || [], modelItem)}
        columns={Func.columnsTable({
          titleTable: titleItemTable,
          component: normalizedComponentTable,
          itemName: 'homestayRate'
        })}
        onChange={this.props.onChange}
        pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent }}
        componentTableList={{}}
        components={isSort && this.components}
        onRow={(record, index) => ({
          record,
          index,
          moveRow,
          onClick: (e) => isSort && this.handleRowSelection(e.shiftKey, index),
          selectedFields,
          headSelectedIndex
        })}
      />
    );
  }

  syncHomestayRate = (homestayId) => {
    this.props.syncHomestayRates(homestayId)
  }

  // cancel = (e) => {
  //   message.error('Click on No');
  // }
  renderEditComponent(item) {
    const { t, permisions, homestayId } = this.props;
    const onChangeTranslate = (item) => {
      this.setState({ itemRow: item })
    }
    const handleCancel = () => {
      this.setState({ itemRow: {} })
    }
    return (
      <Fragment>
        {permisions && permisions.allowUpdate && !_.isEmpty(this.state.itemRow) && this.state.itemRow.id === item.id && <AutoTranslateModal getListHomestayRates={this.props.getListHomestayRates} item={item} handleCancel={() => handleCancel()} />}
        <Ripple className="mr-2">
          <Icon type="global" style={{ padding: '0 10px' }} className="fs20" onClick={() => onChangeTranslate(item)} />
        </Ripple>
        {
          permisions && permisions.allowUpdate &&
          <Link to={Func.getPathWithParams(PATHS.HOMESTAY_RATE.DETAIL.path, { homestay_id: homestayId, id: item.id })} className={`colorPrimary`}>
            <Ripple><Icon type="form" className="fs20" /></Ripple>
          </Link>
        }
      </Fragment>
    )
  }
}

export default withTranslation()(HomestayRateList);
